var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 86,
    viewBox: "0 0 72 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1641 0V86H71.1641V0H70.1641Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9141 40.75C47.9141 53.2375 39.2741 64.915 27.6641 67.75C16.0541 64.915 7.41406 53.2375 7.41406 40.75V27.25L27.6641 18.25L47.9141 27.25V40.75ZM27.6641 63.25C36.1016 61 43.4141 50.965 43.4141 41.245V30.175L27.6641 23.155L11.9141 30.175V41.245C11.9141 50.965 19.2266 61 27.6641 63.25ZM33.9641 40.75V37.375C33.9641 34.225 30.8141 31.75 27.6641 31.75C24.5141 31.75 21.3641 34.225 21.3641 37.375V40.75C20.0141 40.75 18.6641 42.1 18.6641 43.45V51.325C18.6641 52.9 20.0141 54.25 21.3641 54.25H33.7391C35.3141 54.25 36.6641 52.9 36.6641 51.55V43.675C36.6641 42.1 35.3141 40.75 33.9641 40.75ZM31.0391 40.75H24.2891V37.375C24.2891 35.575 25.8641 34.45 27.6641 34.45C29.4641 34.45 31.0391 35.575 31.0391 37.375V40.75Z",
    fill: "url(#paint0_linear_2645_7299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_7299",
    x1: 7.41406,
    y1: 44.8082,
    x2: 48.2944,
    y2: 44.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.c7c99420b9a41dd7c64bd1ef02687a27.svg";
export { ForwardRef as ReactComponent };